import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RegisterApiResponse } from '@core/models/api.response';
import { RegistrationDTO } from '@core/models/dto.models';
import { environment } from '@env/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  constructor(private http: HttpClient) {}

  async register(registerDTO: RegistrationDTO): Promise<RegisterApiResponse> {
    return firstValueFrom(
      this.http.post<RegisterApiResponse>(`${environment.apiUri}/profile/register`, registerDTO)
    );
  }
}
